import { formatApy } from "../../utils/functions/formatApy";
import { Emdash } from "../Punctuation";
import { GridPercentSign } from "./GridPercentSign";

// // // //

/**
 * DataGridPercentChangeValue
 * Render a percent-change widget in DataGridCell
 */
export function DataGridPercentChangeValue(props: { value: number }) {
    const { value } = props;

    if (typeof value !== "number" || Number.isNaN(value)) {
        return <Emdash />;
    }

    if (value === 0) {
        return (
            <span className="text-secondary-foreground">
                {formatApy(value).toFixed(0)}
                <GridPercentSign />
            </span>
        );
    }

    const isPositive = value >= 0;
    const arrowIcon = isPositive ? "▲" : "▼";
    const colorClass = isPositive ? "text-change-up" : "text-change-down";

    // Determine how many sigfigs to use when displaying the value
    const isLessThan100 = Math.abs(value) * 100 < 100;
    const isLessThan10K = Math.abs(value) * 100 < 1000;
    const sigfigs = isLessThan100 ? 2 : isLessThan10K ? 1 : 0;

    // Strip the casing out of this figure since it's handled by the arrow + color
    const formattedValue = Math.abs(formatApy(value)).toLocaleString(
        undefined,
        {
            maximumFractionDigits: sigfigs,
            minimumFractionDigits: sigfigs,
        },
    );

    return (
        <div className="flex items-center space-x-0.5">
            <span className={colorClass}>{arrowIcon}</span>
            <span className={colorClass}>{formattedValue}%</span>
        </div>
    );
}
